export default "{\n    \"sendingText\": \"Sending\"\n}\n"